
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M7.4 8.5L12.17.24a9.984 9.984 0 00-8.49 2.01L7.34 8.6l.06-.1zM19.54 7c-.92-2.92-3.15-5.26-6-6.34L9.88 7h9.66zm.26 1h-7.49l.29.5 4.76 8.25A9.91 9.91 0 0020 10c0-.69-.07-1.35-.2-2zM6.54 10l-3.9-6.75A9.958 9.958 0 00.2 12h7.49l-1.15-2zM.46 13c.92 2.92 3.15 5.26 6 6.34L10.12 13H.46zm11.27 0l-3.9 6.76a9.984 9.984 0 008.49-2.01l-3.66-6.35-.93 1.6z","fill":"#fff"}})])
          )
        }
      }
    